import { GetHestiaPredictionsResponse } from '@api/getHestiaPredictions'

import { CreditCardAlternativeProductsCategory } from '@appTypes/EligibilityApi.interface'

import getIsHighHomeownerLoanLikelihood from './getIsHighHomeownerLoanLikelihood'

const getEligibleAltProductCategories = (
    categories: CreditCardAlternativeProductsCategory[],
    hestia?: GetHestiaPredictionsResponse
) => {
    return categories.filter(category => {
        if (
            category.id === 'Homeowner Loans' &&
            !getIsHighHomeownerLoanLikelihood(hestia)
        ) {
            return false
        }

        return true
    })
}

export default getEligibleAltProductCategories
